let canvas = new fabric.Canvas('bagCanvas');

let bag, handle, bagText;
let initialTextContent;

let productHandle = window.location.pathname.split('/').pop();
//initialTextContent = productHandle === 'regular-handtas' ? 'PP' : 'PP';
initialTextContent = 'PP';

let selectedFont = "Arial-Bold";
let bagFrame = 'https://cdn.shopify.com/s/files/1/0521/8320/4028/files/pollie-bag-body-small.svg?v=1750939778';
let bagHandle = 'https://cdn.shopify.com/s/files/1/0521/8320/4028/files/pollie-handle_1.svg?v=1751364001';
let textPattern = '';

// Load Bag and Handle
Promise.all([
    new Promise(resolve => {
        fabric.loadSVGFromURL(bagFrame, function (objects, options) {
            bag = fabric.util.groupSVGElements(objects, options);
            bag.set({
                left: canvas.width / 2,
                top: canvas.height / 1.6,
                originX: "center",
                originY: "center",
                selectable: false
            });
            canvas.add(bag);
            resolve();
        });
    }),
    new Promise(resolve => {
        fabric.loadSVGFromURL(bagHandle, function (objects, options) {
            handle = fabric.util.groupSVGElements(objects, options);
            handle.set({
                left: canvas.width / 2,
                top: canvas.height / 4,
                originX: "center",
                originY: "center",
                selectable: false
            });
            canvas.insertAt(handle, 0);
            resolve();
        });
    })
]).then(() => {
    // Load font only after bag and handle are added
    loadAndApplyFont("Arial-Bold-new", "https://cdn.shopify.com/s/files/1/0521/8320/4028/files/Arial-Black.woff2?v=1719818668");
});

async function loadAndApplyFont(fontName, fontUrl) {
    try {
        const font = new FontFace(fontName, `url(${fontUrl}) format("woff2")`);
        await font.load();
        document.fonts.add(font);
        console.log(`Font '${fontName}' loaded successfully`);

        // Add text after font is loaded
        setTimeout(() => {
            addTextToBag(initialTextContent, fontName);
        }, 150);
    } catch (err) {
        console.error("Font loading failed:", err);
    }
}

// Add Text
async function addTextToBag(textContent, selectedFont) {
    if (bagText) canvas.remove(bagText); // Remove existing text

    textContent = textContent.toUpperCase();
    const canvasWidth = canvas.width, canvasHeight = canvas.height;

    bagText = new fabric.Text(textContent, {
        fontSize: 60,
        fill: '#f2f2f2',
        originX: "center",
        originY: "center",
        left: canvasWidth / 2,
        top: canvasHeight / 1.6,
        selectable: false,
        fontFamily: selectedFont,
        textAlign: "center",
        fontWeight: 700,
        shadow: new fabric.Shadow({
            color: 'rgba(0, 0, 0, 0.5)',
            blur: 10,
            offsetX: 0,
            offsetY: 0
        })
    });

    canvas.add(bagText);
    canvas.renderAll();
}

// Bag Color Selection
document.querySelectorAll('.getBagColor ul li').forEach(item => {
    item.addEventListener('click', function () {
        const imageUrl = item.querySelector('.preview_img img').src;
        console.log(imageUrl);
        loadPatternToBag(imageUrl);
    });
});

// Handle Color Selection
document.querySelectorAll('.getHandleColor ul li').forEach(item => {
    item.addEventListener('click', function () {
        const imageUrl = item.querySelector('.preview_img img').src;
        loadPatternToHandle(imageUrl);
    });
});

// Text Color Selection
document.querySelectorAll('.getTextColor ul li').forEach(item => {
    item.addEventListener('click', function () {
        const imageUrl = item.querySelector('.preview_img img').src;
        textPattern = imageUrl;
        loadPatternToText(imageUrl);
    });
});

// Position Text
document.querySelector('.PositionLetters').addEventListener('change', function (e) {
    let position = e.target.options[e.target.selectedIndex].getAttribute('data-value');
    updateTextPosition(position);
});

function updateTextPosition(position) {
    if (!bagText) return;

    let newLeft = canvas.width / 2;  
    let newTop = canvas.height / 1.6;

    switch (position) {
        case 'bottom-right':
           newLeft = canvas.width * (productHandle === 'regular-handtas' ? 0.650 : 0.620);
           newTop  = canvas.height * (productHandle === 'regular-handtas' ? 0.780 : 0.720);
           break;
        case 'bottom-left':
            // newLeft = canvas.width * 0.400;
            // newTop = canvas.height * 0.8;
            newLeft = canvas.width * (productHandle === 'regular-handtas' ? 0.350 :  0.42);
            newTop  = canvas.height * (productHandle === 'regular-handtas' ?  0.780 : 0.720);
            break;
        case 'center':
            // Use default values
            break;
    }

    bagText.set({
        left: newLeft,
        top: newTop
    });

    canvas.renderAll();

    // Reapply text pattern after updating position
    if (textPattern) {
        loadPatternToText(textPattern);
    }
}


// Font Selector
document.querySelectorAll(".product-form__item .customRadio input").forEach(radio => {
    radio.addEventListener('change', function() {
        selectedFont = this.getAttribute('family');

        if (bagText) {
            const textContent = bagText.text;
            const currentLeft = bagText.left;  // Preserve current position
            const currentTop = bagText.top;

            canvas.remove(bagText);
            bagText = new fabric.Text(textContent, {
                top: currentTop,
                left: currentLeft,
                originX: "center",
                originY: "center",
                fontFamily: selectedFont,
                fill: '#f2f2f2',
                fontSize: selectedFont === 'Blimey A Black A' ? 70 : 60,
                charSpacing: selectedFont === 'Blimey A Black A' ? 70 : 0,
                fontWeight: selectedFont === 'Blimey A Black A' ? 600 : 700,
                shadow: new fabric.Shadow({
                    color: 'rgba(0, 0, 0, 0.5)',
                    blur: 10,
                    offsetX: 0,
                    offsetY: 0
                })
            });

            canvas.add(bagText);
            bagText.bringToFront();
            canvas.renderAll();

            // Reapply text pattern after changing font
            if (textPattern) {
                loadPatternToText(textPattern);
            }
        }
    });
});

// Function to Apply Pattern
function loadPatternToObject(targetObject, selectedImg) {
    fabric.util.loadImage(selectedImg, function (img) {
        const pattern = new fabric.Pattern({
            source: img,
            repeat: 'no-repeat',
            offsetX: 0,
            offsetY: 0,
            patternTransform: [
                targetObject.width / img.width,
                0,
                0,
                targetObject.height / img.height,
                0,
                0
            ]
        });

        if (targetObject._objects) {
            targetObject._objects.forEach(obj => obj.fill && obj.set('fill', pattern));
        } else {
            targetObject.set('fill', pattern);
        }
        canvas.renderAll();
    });
}

function loadPatternToBag(selectedImg) {
    loadPatternToObject(bag, selectedImg);
}

function loadPatternToHandle(selectedImg) {
    loadPatternToObject(handle, selectedImg);
}

function loadPatternToText(selectedImg) {
    loadPatternToObject(bagText, selectedImg);
}
